import React from "react";
import { Menu, MenuItem, makeStyles } from "@material-ui/core";
import { MenuLists } from "../MenuManageSurveys/MenuManageSurveys.styled";
import { ReactComponent as EditSurveyIcon } from "../../assets/svg/edit-survey-icon.svg";
import { ReactComponent as DeleteSurveyIcon } from "../../assets/svg/delete-survey-icon.svg";
import { ReactComponent as CloneSurveyIcon } from "../../assets/svg/clone-survey-icon.svg";
import { ReactComponent as UserAssignmentIcon } from "../../assets/svg/user-assignment-icon.svg";
import { ReactComponent as PreviewIcon } from "../../assets/svg/preview-icon.svg";

const useStyles = makeStyles(() => ({
  menuBackground: {
    background: "#5D5D5D",
    borderRadius: "10px",
  },
}));

const MenuManageSurveys = ({
  item,
  anchorSelected,
  anchorEl,
  handleCloseActions,
  handleEditSurvey,
  setAnchorEl,
  setAnchorSelected,
  setOpenDeleteModal,
  setOpenCloneSurveyModal,
  setOnlyAssigned,
  handlePreview,
  identity,
  itsSurvey,
  assignedUSers,
}) => {
  const classes = useStyles();

  return (
    <Menu
      id="long-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorSelected === item.idSurvey ? true : false)}
      keepMounted
      transition={"true"}
      onClose={() => handleCloseActions()}
      classes={{
        paper: classes.menuBackground,
      }}
    >
      <MenuItem
        disabled={
          item.idSurveyState === 5 || item.idSurveyState === 7 ? false : true
        }
        onClick={() => handleEditSurvey(item, assignedUSers)}
      >
        <EditSurveyIcon />
        &nbsp; <MenuLists>Edit</MenuLists>
      </MenuItem>
      <MenuItem
        disabled={
          item.idSurveyState === 5 ||
          item.idSurveyState === 4 ||
          item.idSurveyState === 3 ||
          item.idSurveyState === 1 ||
          item.idSurveyState === 7
            ? false
            : true
        }
        onClick={() => {
          setAnchorEl(null);
          setAnchorSelected(null);
          setOpenDeleteModal(item);
        }}
      >
        <DeleteSurveyIcon />
        &nbsp; <MenuLists>Delete</MenuLists>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setAnchorEl(null);
          setAnchorSelected(null);
          setOpenCloneSurveyModal(item);
        }}
      >
        <CloneSurveyIcon />
        {itsSurvey ? (
          <>
            {" "}
            &nbsp; <MenuLists>Clone Survey</MenuLists>{" "}
          </>
        ) : (
          <>
            {" "}
            &nbsp; <MenuLists>Clone Form</MenuLists>{" "}
          </>
        )}
      </MenuItem>
      <MenuItem
        disabled={
          item.idSurveyState === 2 ||
          item.idSurveyState === 1 ||
          item.idSurveyState === 4
            ? false
            : true
        }
        onClick={() => {
          setOnlyAssigned(true);
          handleEditSurvey(item, assignedUSers);
        }}
      >
        <UserAssignmentIcon />
        &nbsp; <MenuLists>User Assignment</MenuLists>
      </MenuItem>
      <MenuItem
        onClick={() => {
          handlePreview(item);
        }}
      >
        <PreviewIcon />
        &nbsp; <MenuLists>Preview</MenuLists>
      </MenuItem>
    </Menu>
  );
};

export default MenuManageSurveys;
